const handlePayload = ({ analysisName, analysisTarget }, datasetParams) => ({
  data_location: datasetParams,
  name: analysisName,
  settings: {
    boosting: false,
    export_mass_market_profiles: true,
    export_optimal_profiles: true,
    segmented: false,
    target: analysisTarget,
  },
});

const getStatusColor = status => {
  switch (status) {
    case "finished":
      return "#ebf4ec";
    case "running":
      return "#E8F4FD";
    case "failed":
      return "#FAEAEA";
    default:
      return "#E8F4FD";
  }
};

const getRoundedPercent = (number, total, decimals) =>
  (Math.round((number + Number.EPSILON) * 100) / total).toFixed(decimals);

const getCleanedTargetText = text =>
  text.includes("{") || text.includes("}")
    ? text
        .replace(/[^\w\s_,s]/gi, "")
        .replace("in", "is")
        .replace(/,(?=[^,]*$)/, ", and ")
    : text
        .replace(/\(?\[?-inf,/gi, "")
        .replace(/\(/gi, "> ")
        .replace(/\[/gi, " \u2265 ")
        .replace(/\d+\)/gi, match => `< ${match.replace(")", "")}`)
        .replace(/\d+\]/gi, match => `\u2264 ${match.replace("]", "")}`)
        .replace(/, \+inf\)?\]?/gi, "")
        .replace("in", "is")
        .replace(",", " and");

const getTargetLabel = expression =>
  expression
    ?.split(" && ")
    .map(target => getCleanedTargetText(target))
    .join(", and ");

const getOutputTypes = outputArray =>
  outputArray.reduce(
    (acc, output) => ({ ...acc, [output.result_type]: output }),
    {}
  );

export {
  handlePayload,
  getStatusColor,
  getRoundedPercent,
  getTargetLabel,
  getOutputTypes,
};
